var accordionKc = {
    accordionKcMobile: function () {
        if (screen && screen.width < 980) {
            $('#accordion').find('.c-kc-page-subcategories-accordion__toggle').click(function(e){
                $(this).next().slideToggle('fast');
                $(this).toggleClass('active');
                
                $(".c-kc-page-subcategories-accordion__content").not($(this).next()).slideUp('fast');
                $(".c-kc-page-subcategories-accordion__toggle").not($(this)).removeClass('active');
            });
            $("div.c-kc-page-subcategories-accordion__content").addClass("defualt-hidden");
        }
    },
}

$(function () {

    if ($('.c-kc-page ').length) {
        accordionKc.accordionKcMobile();
    }
})
